"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VAtoDB = VAtoDB;
exports.VVtoDB = VVtoDB;
exports.dBtoVV = dBtoVV;
exports.degreeToradian = degreeToradian;
exports.getGainDB = getGainDB;
exports.getGainVV = getGainVV;
exports.groupDelay = groupDelay;
exports.hzToRadPerSecond = hzToRadPerSecond;
exports.negatePhase = negatePhase;
exports.phaseDelay = phaseDelay;
exports.radianTodegree = radianTodegree;
var AdiMath = _interopRequireWildcard(require("./math"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function VAtoDB(VA) {
  var log10VA = AdiMath.logBaseTen(VA);
  var db = 20 * log10VA;
  return db;
}

// PRIVATE FUNCTIONS
function radianTodegree(radArray) {
  var newArray = [];
  for (var i = 0; i < radArray.length; i++) {
    newArray.push(radArray[i] * (180 / Math.PI));
  }
  return newArray;
}
function VVtoDB(vv) {
  var log10vv = AdiMath.logBaseTen(vv);
  var db = 20 * log10vv;
  return db;
}
function dBtoVV(db) {
  var x = db / 20;
  var vv = Math.pow(10, x);
  return vv;
}
function degreeToradian(cmag) {
  var newArray = [];
  for (var i = 0; i < cmag.length; i++) {
    var newArrayInner = [];
    newArrayInner.push(cmag[i] * (Math.PI / 180));
    newArray.push(newArrayInner);
  }
  return newArray;
}
function negatePhase(phaseArray) {
  var negatedPhaseArray = [];
  for (var i = 0; i < phaseArray.length; i++) {
    negatedPhaseArray.push(phaseArray[i] * -1);
  }
  return negatedPhaseArray;
}
function hzToRadPerSecond(frequencyArray) {
  var result = [];
  for (var i = 0; i < frequencyArray.length; i++) {
    result.push(frequencyArray[i] * (2 * Math.PI));
  }
  return result;
}
function phaseDelay(phaseArray, frequencyArray) {
  var radPerS = [],
    result = [];

  //convert frequencyArray convert from Hz to rad/s
  radPerS = this.hzToRadPerSecond(frequencyArray);
  //negate Phase Array
  var negatedPhaseArray = this.negatePhase(phaseArray);
  //divide negatedPhase array by frequency array
  for (var m = 0; m < radPerS.length; m++) {
    result.push(negatedPhaseArray[m] / radPerS[m]);
  }
  return result;
}
function groupDelay(phaseArray, frequencyArray) {
  var frequencyDifference, phaseDifference;
  var groupDelayArray = [];
  var newFrequencyAxis = [];
  var negatedPhaseArray = this.negatePhase(phaseArray);

  //convert array from Hz to rad/s
  var frequencyRadPerSecondArray = this.hzToRadPerSecond(frequencyArray);

  //loop through negatedPhaseArray
  for (var i = 1; i < negatedPhaseArray.length; i++) {
    //calculate frequencyDifference 
    frequencyDifference = frequencyRadPerSecondArray[i] - frequencyRadPerSecondArray[i - 1];

    //calculate phaseDifference
    phaseDifference = negatedPhaseArray[i] - negatedPhaseArray[i - 1];

    //calculate groupDelay
    groupDelayArray.push(phaseDifference / frequencyDifference);

    //use original frequencyArray to calculate newFrequencyAxis
    newFrequencyAxis.push(Math.sqrt(frequencyArray[i] * frequencyArray[i - 1]));
  }

  //prepare array (Group Delay plotted against NewFrequencyAxis x,y respectfully)
  return [groupDelayArray, newFrequencyAxis];
}
function getGainDB(gain, gainUnit) {
  if (gain != 0) {
    gain = gainUnit == 'dB' ? gain : this.VVtoDB(gain);
  }
  return parseInt(gain);
}
function getGainVV(gain, gainUnit) {
  if (gainUnit == 'dB') {
    gain = this.dBtoVV(gain);
  }
  return parseInt(gain);
}